import * as Yup from "yup"
import { AcademicLevel, Accompagnateurs, Availabilities, CampaignId, Campus, Consentement, Email, FirstName, LastName, MobilePhone, Salutation, Section, SlotId, Specialites } from "services/validation"

const schema = Yup.object().shape({
  ...Accompagnateurs,
  ...Availabilities,
  ...CampaignId,
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhone,
    ...Salutation,
    ...Section
  }),
  ...SlotId,
  ...Specialites
})

export default schema
